var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"bottom-control clearfix"},[_c('div',{staticClass:"left"},[_vm._t("left")],2),_vm._t("header"),_c('div',{staticStyle:{"text-align":"center"}},[_vm._t("right")],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }